// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"_21FsqECkH2nrae7CjzpxAj","cancelBtn":"_2IgWnpGH_d9ey7NwNHON7A","icon":"LSRxWizuOXTsVxRWB5EHG","saveBtn":"_1SfCZg9CLJ3jM_qvgyPvUG"};